export const GroupByHeaderSubMenu = [
  { title: " " },
  {
    title: "Project(s)",
    subMenu: [
      {
        title: "Total Projects",
        sortOrder: "asc",
        targetField: "totalProjects"
      },
      { title: "Open", sortOrder: "asc", targetField: "openProjects" },
      { title: "Resolved", sortOrder: "asc", targetField: "resolvedProjects" },
      { title: "Cost", sortOrder: "asc", targetField: "totalProjectCost" }
    ]
  },
  {
    title: "Issue(s)",
    subMenu: [
      { title: "Total Issues", sortOrder: "asc", targetField: "totalIssues" },
      { title: "Open", sortOrder: "asc", targetField: "openIssues" },
      { title: "Resolved", sortOrder: "asc", targetField: "resolvedIssues" }
    ]
  }
];

export const GroupByHeader = [
  { title: "Group(s)" },
  { title: "Project(s)" },
  { title: "Issue(s)" }
];

export const Title = {
  projectCost: "Project(s) Value",
  projectCount: "Project(s) Monitored",
  issueCount: "Issue(s)  Monitored",
  pragatiReview: "Pragati Project(s)"
};
